import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

export const useStatusBar = () => {
  useEffect(() => {
    const configureStatusBar = async () => {
      if (!Capacitor.isNativePlatform()) return;

      try {
        // Set status bar style based on theme
        const isDarkMode = document.documentElement.classList.contains('dark') ||
          window.matchMedia('(prefers-color-scheme: dark)').matches;
        
        await StatusBar.setStyle({
          style: isDarkMode ? Style.Dark : Style.Light
        });

        // Make status bar overlay content (for edge-to-edge design)
        await StatusBar.setOverlaysWebView({ overlay: true });

        // Set background color to transparent for translucent effect
        if (Capacitor.getPlatform() === 'android') {
          await StatusBar.setBackgroundColor({ color: '#00000000' });
        }
      } catch (error) {
        console.warn('Status bar configuration failed:', error);
      }
    };

    configureStatusBar();

    // Listen for theme changes
    const observer = new MutationObserver(async () => {
      if (!Capacitor.isNativePlatform()) return;
      const isDarkMode = document.documentElement.classList.contains('dark');
      try {
        await StatusBar.setStyle({
          style: isDarkMode ? Style.Dark : Style.Light
        });
      } catch (error) {
        console.warn('Status bar style update failed:', error);
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    return () => observer.disconnect();
  }, []);
};
